export const TRANSPORT_TYPE_CODE = {
  RICKSHAW: 'R',
  VAN_OR_TEMPO: 'V',
  BUS_CAR_OR_SHIP: 'B',
  CNG_OR_MOTOR_BIKE: 'C',
  WALK: 'W',
  RIDE_SHARE: 'U',
} as const;
